/**
 * Product Image Local Zoom
 * Click to zoom in 1.5x locally, move mouse to pan, click again to zoom out
 */

class ProductImageZoom {
  constructor(container) {
    this.container = container;
    this.init();
  }

  init() {
    const images = this.container.querySelectorAll('.product-media-container--image');

    images.forEach((mediaContainer) => {
      const img = mediaContainer.querySelector('img');
      const imgWrapper = mediaContainer.querySelector('.product-media-constraint-wrapper') || mediaContainer;

      if (!img) return;

      // Store zoom state per image
      const zoomState = {
        isZoomed: false,
        scale: 1.5,
        boundX: 0,
        boundY: 0,
        container: mediaContainer
      };

      // Add zoom cursor style
      mediaContainer.style.cursor = 'zoom-in';
      imgWrapper.style.overflow = 'hidden';
      img.style.transformOrigin = 'center center';
      img.style.willChange = 'transform';
      img.style.transform = 'scale(1)';
      img.style.translate = '0px 0px';

      // Click to toggle zoom - listen on the container
      mediaContainer.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleZoom(e, img, imgWrapper, zoomState);
      });

      // Mouse move to pan when zoomed
      mediaContainer.addEventListener('mousemove', (e) => this.handlePan(e, img, imgWrapper, zoomState));

      // Reset on mouse leave
      mediaContainer.addEventListener('mouseleave', () => {
        if (zoomState.isZoomed) {
          this.resetZoom(img, imgWrapper, zoomState);
        }
      });
    });
  }

  handleZoom(e, img, imgWrapper, zoomState) {
    if (zoomState.isZoomed) {
      // Zoom out
      this.resetZoom(img, imgWrapper, zoomState);
    } else {
      // Zoom in
      this.doZoom(img, imgWrapper, zoomState, e);
    }
  }

  doZoom(img, imgWrapper, zoomState, e) {
    const rect = imgWrapper.getBoundingClientRect();

    // Get click position relative to image
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    // Calculate percentages for transform origin
    const xPercent = (x / rect.width) * 100;
    const yPercent = (y / rect.height) * 100;

    // Set transform origin to click position
    img.style.transformOrigin = `${xPercent}% ${yPercent}%`;
    img.style.transform = `scale(${zoomState.scale})`;

    // Calculate bounds for panning
    const scaledWidth = rect.width * zoomState.scale;
    const scaledHeight = rect.height * zoomState.scale;
    zoomState.boundX = (scaledWidth - rect.width) / 2;
    zoomState.boundY = (scaledHeight - rect.height) / 2;

    zoomState.isZoomed = true;
    imgWrapper.style.cursor = 'grab';
    zoomState.container.style.cursor = 'grab';
  }

  resetZoom(img, imgWrapper, zoomState) {
    img.style.transform = 'scale(1)';
    img.style.transformOrigin = 'center center';
    img.style.translate = '0px 0px';
    zoomState.isZoomed = false;
    zoomState.boundX = 0;
    zoomState.boundY = 0;
    imgWrapper.style.cursor = 'zoom-in';
    zoomState.container.style.cursor = 'zoom-in';
  }

  handlePan(e, img, imgWrapper, zoomState) {
    if (!zoomState.isZoomed) return;

    const rect = imgWrapper.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    // Calculate offset from center
    const centerX = rect.width / 2;
    const centerY = rect.height / 2;

    // Calculate new position (inverted for natural pan feel)
    const offsetX = -(x - centerX) * (zoomState.scale - 1);
    const offsetY = -(y - centerY) * (zoomState.scale - 1);

    // Clamp to bounds - ensure image doesn't exceed original boundaries
    const clampedX = Math.max(-zoomState.boundX, Math.min(zoomState.boundX, offsetX));
    const clampedY = Math.max(-zoomState.boundY, Math.min(zoomState.boundY, offsetY));

    img.style.translate = `${clampedX}px ${clampedY}px`;
  }
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  const gallery = document.querySelector('.media-gallery--grid');
  if (gallery) {
    new ProductImageZoom(gallery);
  }
});

// Reinitialize if gallery is dynamically loaded
document.addEventListener('shopify:section:load', (e) => {
  const gallery = e.target.querySelector('.media-gallery--grid');
  if (gallery) {
    new ProductImageZoom(gallery);
  }
});
